<template>
  <div class="panel_sale">
    <div class="list" v-if="type === 'list'">
      <huiyuanquanyiList></huiyuanquanyiList>
    </div>
    <div class="add" v-if="type === 'seeBingli'">
      <huiyuanquanyiSeeBingli></huiyuanquanyiSeeBingli>
    </div>
    <div class="add" v-if="type === 'see'">
      <huiyuanquanyiSee></huiyuanquanyiSee>
    </div>
    <div class="add" v-if="type === 'seesee'">
      <huiyuanquanyiSeeSee></huiyuanquanyiSeeSee>
    </div>
  </div>
</template>
<script>
import huiyuanquanyiList from "./comp/huiyuanquanyi_list.vue";
import huiyuanquanyiSee from "./comp/huiyuanquanyi_see.vue";
import huiyuanquanyiSeeSee from "./comp/huiyuanquanyi_seesee.vue";
import huiyuanquanyiSeeBingli from "./comp/huiyuanquanyi_seeBingli.vue";
export default {
  components: {
    huiyuanquanyiList,
    huiyuanquanyiSeeBingli,
    huiyuanquanyiSee,
    huiyuanquanyiSeeSee,
  },
  data() {
    return {};
  },
  computed: {
    type() {
      return this.$store.state.huiyuanquanyi.type;
    },
  },
  mounted() {
    
  },
  methods: {
	
  },
};
</script>
<style scoped lang="scss">
.panel_sale {
  position: relative;
  width: 100%;
  height: 100%;
  .settlementBox {
    position: absolute;
    z-index: 11;
    bottom: 0;
    width: 100%;
  }
  .list {
    height: 100%;
  }
  .add {
    height: 100%;
  }
}
</style>
